import { RadioGroup } from "components/RadioGroup";
import { RatesSatisfaction } from "components/Rates";
import Input from "components/shared/inputs/input";
import useTranslation from "utils/hooks/useTranslation";
import { useSatisfactionForm } from 'utils/hooks/useSatisfactionForm';
import { SvgClock, SvgPointer } from "components/svg";
import NavigationButtons from "components/NavigationButtons";
import { TextAreaControl } from "components/TextAreaControl";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";

export const SatisfactionPage: React.FC = () => {
  const { t } = useTranslation();
  const { isThermor } = useSalesNetwork();
  const { formData, handleFieldChange, submitForm } = useSatisfactionForm();

  const handleSubmit = () => {
    submitForm();
  };

  const renderRadioOption = (name: string, value: string, label: string) => (
    <group data-length="110" data-space="10">
      <label radio="" className="" aria-describedby="«r2n»" data-name="satisfaction yes_no">
        <input
          type="radio"
          value={value}
          name={name}
          checked={formData[name] === value}
          onChange={() => handleFieldChange(name, value)}
        />
        <box><check></check></box>
        <text data-space-horizontal="10">{t(label)}</text>
      </label>
    </group>
  );

  return (
    <group data-direction="column" data-align="center">
      <group data-space-vertical="20" data-space-horizontal="5" data-gap="20" data-max-length="800" data-direction="column">
        <group data-wrap="no" data-space="10" data-space-vertical="10" data-gap="20" data-max-length="800">
          <group data-height="50" data-length="5" 
            {...(!isThermor ? {"data-background":"main"} : {})}
            ></group>
          <group data-length="autofit">
            <text data-color="main" data-text-size="xx-large">{t("SATISFACTION")}</text>
          </group>
        </group>

        <group data-length="autofit" data-gap="10" data-align="center">
          <text data-weight="400" data-text-size="15" data-ellipsis data-color="grey-color-dark">
            {t("SATISFACTION_SEND_SUCCESS")}
          </text>
        </group>

        <group data-length="autofit" data-gap="10" data-space-bottom="20" data-text-size="medium">
          <group data-gap="15" data-align="center" data-name="custom_option">
            <group
              //data-length="300"
              data-radius="5"
              data-height="25"
              data-space="10"
              data-space-horizontal="16"
              data-color="main"
              data-background="main-color-custom-lighter"
              data-width="auto"
            >
              <group data-justify="center" data-gap="10" data-wrap="no">
                <icon data-svg-size="20" data-svg-color="main"><SvgPointer /></icon>
                <text data-clamp="2" data-color="black">{t("SURVEY_FASTLY")}</text>
              </group>
            </group>
            <group
              //data-length="230"
              data-radius="5"
              data-height="25"
              data-space="10"
              data-space-horizontal="16"
              data-color="main"
              data-background="main-color-custom-lighter"
              data-width="auto"
            >
              <group data-justify="center" data-gap="10" data-wrap="no">
                <icon data-svg-size="20" data-svg-color="main"><SvgClock /></icon>
                <text data-clamp="2" data-color="black">{t("SURVEY_5MIN")}</text>
              </group>
            </group>
          </group>
        </group>

        <group data-length="autofit">
          <group data-gap="10" data-space-vertical="10" data-radius="10" data-direction="column">
            <text data-weight="600" data-text-size="large" data-ellipsis data-color="grey-color-dark" data-space-bottom="10">
              {t("QUIZ_QUESTION1")}<i data-color="red">*</i> :
            </text>
            <RatesSatisfaction
              values={formData}
              onChange={(name, value) => handleFieldChange(name, Number(value))}
            />
          </group>
        </group>

        <group data-length="autofit" data-gap="20">
          <group data-gap="10" data-space-vertical="10" data-radius="10" data-direction="row">
            <text data-weight="600" data-text-size="large" data-wrap="wrap" data-color="grey-color-dark">
              {t("QUIZ_QUESTION")}
              {/* <text data-weight="400"> (aides contextuelles, FAQ, Tutos)</text> ? */}
              <i data-color="red">*</i>
            </text>
            <group data-gap="1" data-contain data-direction="row">
              {renderRadioOption("TOOL_GIVE_HELP_SATISFACTION", "1", "YES")}
              {renderRadioOption("TOOL_GIVE_HELP_SATISFACTION", "0", "NO")}
            </group>
          </group>
        </group>

        <group data-length="autofit" data-gap="20">
          <group data-gap="10" data-space-vertical="10" data-radius="10" data-direction="row">
            <text data-weight="600" data-text-size="large" data-wrap="wrap" data-color="grey-color-dark">
              {t("GIVE_IT_HELP_SATISFACTION")} <i data-color="red">*</i>
            </text>
            <group data-gap="1" data-contain data-direction="row">
              {renderRadioOption("GIVE_IT_HELP_SATISFACTION", "1", "YES")}
              {renderRadioOption("GIVE_IT_HELP_SATISFACTION", "0", "NO")}
            </group>
          </group>
        </group>

        <group data-space-vertical="10" data-gap="20">
          {/* <Input
            name="GIVE_IT_HELP_PLUS_SATISFACTION"
            dataLength="700"
            labelSize={12}
            data-text-size="medium"
            label={"GIVE_IT_HELP_PLACEHOLDER"}
            type="textarea"
            size="large"
            rows="6"
            placeholder={t("QUIZ_PLACEH1")}
            value={formData.GIVE_IT_HELP_PLUS_SATISFACTION || ""}
            onChange={(e) => handleFieldChange("GIVE_IT_HELP_PLUS_SATISFACTION", e.target.value)}
          // button={<group data-length="30" data-align="end" data-height="auto">
          //           <icon data-svg-size="24" data-svg-color="main"><SvgSupprimer /></icon>
          //         </group>}
          /> */}

          <TextAreaControl 
          name="GIVE_IT_HELP_PLUS_SATISFACTION"
            dataLength="700"
            labelSize={12}
            data-text-size="medium"
            label={"GIVE_IT_HELP_PLACEHOLDER"}
            type="textarea"
            size="large"
            rows="6"
            placeholder={t("QUIZ_PLACEH1")}
            value={formData.GIVE_IT_HELP_PLUS_SATISFACTION || ""}
            onChange={(e: any) => handleFieldChange("GIVE_IT_HELP_PLUS_SATISFACTION", e.target.value)}
          />
        </group>

        <group data-length="autofit" data-gap="20">
          <group data-gap="10" data-space-vertical="10" data-radius="10" data-direction="row">
            <text data-weight="600" data-text-size="large" data-wrap="wrap" data-color="grey-color-dark">
              {t("APP_IS_HELPFULL")} <i data-color="red">*</i>
            </text>
            <RadioGroup
              name="APP_IS_HELPFULL"
              value={formData.APP_IS_HELPFULL}
              onChange={(value) => handleFieldChange("APP_IS_HELPFULL", value)}
            />
          </group>
        </group>

        <group data-space-vertical="10" data-gap="20">
          <TextAreaControl
            name="SUGGESTION"
            dataLength="700"
            labelSize={12}
            label={"SUGGESTION"}
            type="textarea"
            data-text-size="medium"
            size="large"
            rows="6"
            placeholder={t("SUGGESTION_PLACEHOLDER")}
            value={formData.SUGGESTION || ""}
            onChange={(e: any) => handleFieldChange("SUGGESTION", e.target.value)}
          />
        </group>

        <group data-space-vertical="15" data-gap="10">
          {/* <Button large accent text={t("SEND")} onClick={handleSubmit} /> */}
          <NavigationButtons handleSave={handleSubmit} saveText={t('SEND')} hidePrev={true} hideNext={true} horisontalSpace={0} accent={false} showIcon={false} />
        </group>

        <group data-align="center">
          <text data-weight="400" data-text-size="17" data-color="grey-color-dark">
            <i data-space-horizontal="5" data-color="red">*</i> {t("REQUIRED_FIELDS")}
          </text>
        </group>
      </group>
    </group>
  );
};